import React from "react";
import { BrowserProps } from "../../types/wizard.types";

const Browser: React.FC<BrowserProps> = ({ url }) => {
  return (
    <div className="tw-bg-gray-800 tw-px-3 tw-py-3 tw-flex tw-flex-col tw-justify-between">
      {/* Browser Controls */}
      <div className="tw-flex tw-items-center tw-gap-2 tw-pb-3">
        <div className="tw-flex tw-gap-2">
          <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-red-500"></div>
          <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-yellow-500"></div>
          <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-green-500"></div>
        </div>
      </div>

      {/* URL Bar */}
      <div className="tw-flex tw-items-center tw-gap-2">
        <div className="tw-text-gray-400">
          <svg
            className="tw-w-4 tw-h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>
        <div className="tw-flex-1 tw-bg-gray-700 tw-rounded tw-px-3 tw-py-2 tw-text-white tw-text-sm tw-font-mono tw-tracking-wide">
          <span className="tw-text-green-400">https://</span>
          <span className="tw-transition-all tw-duration-300">{url}</span>
        </div>
        <button className="tw-text-gray-400 hover:tw-text-white tw-transition-colors">
          <svg
            className="tw-w-4 tw-h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Browser;
